/**
 * PanCancer module
 */
import {NgModule} from '@angular/core';
import {CoreModule} from '@ispm/core/core.module';
import {SharedModule} from '@ispm/shared/shared.module';
import {PanCancerCardComponent} from '../pan-cancer/components/pan-cancer-card-dashboard/pan-cancer-card/pan-cancer-card.component';
import {PanCancerCardDashboardComponent} from './components/pan-cancer-card-dashboard/pan-cancer-card-dashboard.component';
import {CardModule} from 'primeng/card';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {LayoutEngineModule} from '@ispm-client/modules/layout-engine/layout-engine.module';
import {WidgetsModule} from '@ispm/widgets/widgets.module';
import {AggregatorModule} from '@ispm-client/modules/aggregator/aggregator.module';
import {PanCancerDynamicFormModalComponent} from '@ispm-client/modules/pan-cancer/components/pan-cancer-dynamic-form-modal/pan-cancer-dynamic-form-modal.component';
import {LayoutModule} from '@ispm/layout/layout.module';
import {EventsModule} from '@ispm-client/modules/events';
import {PatientModule} from '@ispm-client/modules/patient';
import {SelectionItemModule} from '@ispm-client/modules/selection-item/selection-item.module';
import {ContextProviderModule} from '@ispm-client/modules/context-provider';
import {PanCancerCardHeaderComponent} from './components/pan-cancer-card-dashboard/pan-cancer-card/pan-cancer-card-header/pan-cancer-card-header.component';

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    CardModule,
    DynamicFormModule,
    LayoutEngineModule,
    WidgetsModule,
    AggregatorModule,
    LayoutModule,
    EventsModule,
    PatientModule,
    SelectionItemModule,
    ContextProviderModule,
  ],
  declarations: [PanCancerCardDashboardComponent, PanCancerCardComponent, PanCancerDynamicFormModalComponent, PanCancerCardHeaderComponent],
  providers: [],
  exports: [PanCancerCardDashboardComponent, PanCancerDynamicFormModalComponent]
})
export class PanCancerModule {
}
